const QUERIES = {
  BATCH_LIST: 'batch-list',
  USERS_LIST: 'users-list',
  CAMPAIGN_LIST: 'campaigns-list',
  PERMISSION_LIST: 'permission-list',
  ROLE_LIST: 'role-list',
  TICKET_LIST: 'ticket-list',
  TEMPLATEMESSAGES_LIST: 'templatemessages-list',
  MENU_LIST: 'menu-list',
  LOV_LIST: 'lov-list',
  JOBSCHEDULER_LIST: 'jobscheduler-list',
  DATASOURCE_LIST: 'datasource-list',
  AUTORESPOND_LIST: 'autorespond-list',
  INCOMINGMESSAGES_LIST: 'incomingmessages-list',
}

export {QUERIES}
